import React from "react"
import { NavLink } from "react-router-dom"
import { Grid, Icon, Card } from "semantic-ui-react"
import { getAge } from "uikit"

export const Child = ({ id, first_name, birth_date, baseUrl }) => (
  <Card>
    <Card.Content>
      <Grid>
        <Grid.Row columns={2}>
          <Grid.Column textAlign="left">
            <NavLink to={`${baseUrl}/person/${id}`} className="navlink">
              <span className="GenericCard__LinkTitle">
                {first_name}
                <Icon name="chevron right" size="small" />
              </span>
            </NavLink>
          </Grid.Column>
          <Grid.Column textAlign="right">
            <p className="GenericCard__Balance">{getAge(birth_date)}</p>
            <p className="greyed-text">age</p>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Card.Content>
  </Card>
)
